import { IService } from '../../types';

interface IKeyFeatures {
  services: IService[];
  textClasses?: string;
  servicesToShow?: number;
}

export const KeyFeatures: React.FC<IKeyFeatures> = ({
  services,
  textClasses = 'text-base',
  servicesToShow = 3,
}) => {
  if (!services || !services.length) return <></>;
  return (
    <>
      {services.slice(0, servicesToShow).map((item, index) => (
        <div
          className={`flex ${index === servicesToShow - 1 ? '' : 'mb-3'}`}
          key={index}
        >
          <img
            src="https://assets1.cleartax-cdn.com/cleartax/images/1679996776_vector621.png"
            height={15}
            width={15}
            alt={'check'}
            className="self-center mr-3"
          ></img>
          <div
            className={`richTextServiceIncluded flex w-10/12 sm:w-11/12 ${textClasses}`}
            dangerouslySetInnerHTML={{ __html: item.richText }}
          ></div>
        </div>
      ))}
    </>
  );
};
